import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    filenameConstraint: Object,
    url: String,
    method: String,
  };

  removeRow() {
    let element = this.element;

    $(element).parents('.remove-row').fadeOut(100, function () {
      $(this).empty();
      return false;
    });
  }

  validate(event) {
    const fileInput = event.target;
    const fileName = fileInput.value;
    const filenameConstraint = this.filenameConstraintValue;
    const errors = []

    if(this.hasFilenameConstraintValue) {
      const regex = new RegExp(filenameConstraint.validation, 'i');
      if (!regex.test(fileName)) {
        const errorMessage = filenameConstraint.message;
        errors.push(errorMessage);
      }
    }

    const form = fileInput.closest('form');
    const describedBy = fileInput.getAttribute('aria-describedby');
    const fileErrorField = (describedBy && document.getElementById(describedBy)) ||
                           form.querySelector('.file-error');
    const submitButton = form.querySelector('[type="submit"]');
    const isInvalid = errors.length > 0;

    if (fileErrorField) {
      fileErrorField.textContent = isInvalid ? errors.join(', ') : '';
      fileErrorField.classList.toggle('error', isInvalid);
    }

    if (submitButton) submitButton.disabled = isInvalid;
  }

  updateForm(event) {
    showLoadingSpinner();

    const form = $(event.target.closest('form'));
    const $target = $(event.target);

    if (form.attr('data-remote') === 'true') {
      const currentUrlWithoutParams = new URL(window.location.href).toString().split('?')[0];

      const formData = form.serializeArray();
      const targetName = $target.attr('name');
      const targetValue = $target.val();

      if (
        targetName &&
        !formData.some(field => field.name === targetName && field.value == targetValue)
      ) {
        formData.push({ name: targetName, value: targetValue });
      }

      $.ajax({
        type: this.methodValue  || form.attr('method')  || 'GET',
        url:  this.urlValue     || form.attr('action')  || currentUrlWithoutParams,
        dataType: 'script',
        data: $.param(formData)
      });
    } else {
      form[0].submit();
    }
  }

}
